<template>
    <div style="border-bottom: 1px solid #ebebeb; background-color: white;">
        <v-list-item dense style="min-height: 48px;" link @click="$emit('edit', item)">
            <v-list-item-icon class="mr-3 my-auto">
                <v-icon :color="item.Color" size="20">{{ item.Icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0">
                <v-list-item-title>
                    {{ item.Name }}
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>


        <div :class="(item.Id < 70 || children && children.length) ? 'status-indent' : ''">
            <template v-if="children && children.length">
                <div v-for="child in children" :key="child.Id" class="substatusindent">
                    <v-list-item :class="child.IsActive ? '' : 'deactivated'" dense style="min-height: 32px;" link
                        @click="$emit('edit', child)">
                        <v-list-item-icon class="mr-3 my-auto">
                            <v-icon size="18">mdi-folder</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="pa-0">
                            <v-list-item-title>
                                {{ child.Name }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>
            </template>
            <v-btn v-if="item.Id < 70" text style="text-transform: none;" color="success" height="32"
                @click="initiateNewSubstatus()">
                <v-icon size="15" class="pl-1 mr-4">mdi-plus</v-icon>
                {{ $t('servicesystem.common_objects.commonterms.new') }} {{
                $t('servicesystem.common_objects.job.substatus') }}
            </v-btn>
        </div>

    </div>
</template>


<script>
export default {
    name: 'JobStatusListItem',
    props: {
        item: Object,
    },

    data() {
        return {
        };
    },

    methods: {
        initiateNewSubstatus() {
            var newSubstatus = {
                Id: 0,
                Name: '',
                ParentId: this.item.Id,
            };
            this.$emit('edit', newSubstatus);
        },
    },

    computed: {
        children() {
            return this.item.JobSubStatuses;
        },
    },
};
</script>


<style lang='scss'>
.status-indent {
    position: relative;
    margin-left: 27px;
}

.status-indent::after,
.status-indent:before,
.substatusindent::before {
    content: '';
    display: block;
    position: absolute;
    background-color: #ebebeb;
    z-index: 5;
    left: 0;
}

.status-indent::after {
    height: calc(100% - 10px);
    width: 3px;
    bottom: 14.5px;
}

.status-indent:before {
    height: 3px;
    width: 17px;
    bottom: 14.5px;
}

.substatusindent::before {
    height: 3px;
    width: 12px;
    margin-top: 16px;
}

.deactivated {
    background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
    color: var(--v-disabled-darken2) !important;
    text-decoration: line-through !important;
}
</style>